import { BillerPlansPayload } from "features/bbps/biller/billerFlowTypes";
import { call, put, takeLatest } from "redux-saga/effects";
import billerService from "services/api.services/biller/billerService";
import { NormalizedError } from "services/axios.services/interceptors/commonInterceptors";
import {
  billerPlansSucceeded,
  billerPlansFailed,
  billerPlansRequested,
} from "./billerPlanSlice";

function* handleBillerPlans(action: {
  type: string;
  payload: BillerPlansPayload;
}): Generator<any, any, any> {
  try {
    // Service layer call
    // const plans: BillerPlan[] = yield call(
    //   fetchBillerPlansService,
    //   action.payload
    // );

    // console.log("plansagapayloadreq", action.payload);

    const plans: any = yield call(billerService.fetchPlans, action.payload);

    // Extra safety: empty plans allowed as well, to direct success
    yield put(billerPlansSucceeded(plans.planDetails));
  } catch (err: any) {
    const normalized: NormalizedError = err;
    yield put(billerPlansFailed(normalized));
  }
}

export function* billerPlansWatcher() {
  // console.log("billerPlansRequested in saga:", billerPlansRequested);

  yield takeLatest(billerPlansRequested.type, handleBillerPlans);
}
